export const getLocationDetails = (locationDetails: any) => {
  if ((locationDetails || []).length === 0) {
    return null;
  }
  return (locationDetails || []).map(
    ({ attributes: { location_name, location_state, location_city, facility_sms_id } }: any) => ({
      location_name,
      location_state: location_state?.toLowerCase() || '',
      location_city: location_city?.toLowerCase() || '',
      facility_sms_id,
    }),
  );
};

export const getCurrentLocation = (locationDetails: any, currentFacilityId: string) => {
  if (locationDetails && locationDetails.length > 1) {
    return locationDetails.filter(
      (eachLocation: any) => eachLocation.attributes?.facility_sms_id === currentFacilityId,
    )[0];
  } else {
    return locationDetails?.[0];
  }
};

export const getFacilitySmsId = (
  locationDetails: any,
  loggedInSmsFacilityId: string | undefined,
  facilityDetails: any,
) => {
  if (locationDetails && locationDetails.length > 1) {
    return loggedInSmsFacilityId || locationDetails?.[0]?.attributes?.facility_sms_id;
  } else {
    return facilityDetails.facility_sms_id;
  }
};
